import { Content } from 'antd/lib/layout/layout';
import Title from 'antd/lib/typography/Title';
import * as React from 'react';
import styles from '../styles/appStyles';
import Text from 'antd/lib/typography/Text';
import Space from 'antd/lib/space';
import Button from 'antd/lib/button';
import { Redirect } from 'react-router-dom';
import routes from '../../routes';
import { RootState } from '../../reducers/reducers';
import { useDispatch, useSelector } from 'react-redux';
import * as API from '../../api';
import * as Storage from '../../helpers/localStorageHelper';
import { tryLogout } from '../../actions/login';
import { globalMessage } from '../../utils/globalMessage';

const EmailVerificationComponent: React.FC = () => {
    const auth = useSelector((state: RootState) => state.auth);
    const dispatch = useDispatch();

    const [isResendEmailVerificationLoading, setIsResendEmailVerificationLoading] = React.useState(false);

    if (!auth.isLoggedIn) {
        const lastLogin = Storage.getItem(Storage.LAST_LOGIN);
        const hasPreviouslyLoggedIn = lastLogin !== null;
        const redirectRoute = hasPreviouslyLoggedIn ? routes.login : routes.signup;

        console.debug(
            '[REDIRECT DEBUG]',
            'current route: /login/verifyEmail',
            '-> next route:',
            redirectRoute,
            '(not logged in during email verification)',
        );
        return <Redirect to={{ pathname: redirectRoute }} />;
    }

    const authCredentials = auth.authCredentials;

    const onClickResendEmail = () => {
        setIsResendEmailVerificationLoading(true);

        API.resendVerificationEmail(authCredentials)
            .then(() => {
                globalMessage.success('Verification email sent!');
                return;
            })
            .catch((e) => {
                globalMessage.error(e.message);
                return;
            })
            .finally(() => setIsResendEmailVerificationLoading(false));
    };

    const onClickStartOver = () => {
        dispatch(tryLogout());
    };

    return (
        <Content style={styles.centerVerticalAndHorizontal}>
            <Space direction="vertical" size={42} align="center">
                <Space direction="vertical" align="center">
                    <Title style={{ fontSize: 24, lineHeight: '24px' }}>Confirm your email</Title>
                    <Text type="secondary">
                        We sent a confirmation email to{' '}
                        <Text strong type="secondary">
                            {authCredentials.userEmail}
                        </Text>
                        .
                    </Text>
                </Space>
                <Space direction="vertical" align="center">
                    <Button type="primary" loading={isResendEmailVerificationLoading} onClick={onClickResendEmail}>
                        Resend confirmation email
                    </Button>
                    <Button type="link" onClick={onClickStartOver}>
                        Start over
                    </Button>
                </Space>
            </Space>
        </Content>
    );
};

export default EmailVerificationComponent;
